import { cva } from 'class-variance-authority'

export const readingVariants = {
  layout: cva([
    'max-w-9xl',
    'pt-s',
    'mx-auto',
    'px-s',
    'relative',
    'transition-[width]',
    'ease-in-out',
    'duration-500',
    'bg-surface-primary',
  ], {
    variants: {
      fixedContent: {
        true: ['px-s', 'h-screen'],
        false: [],
      },
    },
  }),

  sidebar: cva([
    'flex',
    'flex-col',
    'transition-[width]',
    'ease-in-out',
    'duration-500',
    'bg-surface-elevated',
    'rounded-tl-4xl',
    'gap-m',
  ], {
    variants: {
      expanded: {
        true: ['w-[273px]', 'md:w-[380px]', 'max-w-[380px]', 'pr-0', 'pt-m', 'pl-m'],
        false: ['w-14.5', 'pt-4xl', 'items-center'],
      },
    },
  }),

  content: cva([
    'relative',
    'flex',
    'flex-col',
    'overflow-hidden',
    'transition-[width]',
    'ease-in-out',
    'duration-500',
  ], {
    variants: {
      hasAside: {
        true: ['rounded-tr-4xl', 'lg:rounded-none', 'gap-2xs'],
        false: ['rounded-tr-4xl'],
      },
      licensed: {
        true: ['bg-surface-elevated'],
        false: ['bg-surface-hover'],
      },
      expanded: {
        true: ['pb-l', 'w-full'],
        false: ['w-14.5', 'pt-4xl', 'items-center'],
      },
    },
  }),

  aside: cva([
    'relative',
    'hidden',
    'lg:flex',
    'flex-col',
    'transition-[width]',
    'ease-in-out',
    'duration-500',
    'min-w-0',
    'pl-m',
    'overflow-hidden',
  ], {
    variants: {
      expanded: {
        true: ['py-m'],
        false: [],
      },
      width: {
        wide: [],
        narrow: [],
      },
      licensed: {
        true: ['bg-surface-elevated'],
        false: ['bg-surface-hover'],
      },
      hasReference: {
        true: ['rounded-none'],
        false: ['lg:rounded-tr-4xl'],
      },
    },
    compoundVariants: [
      {
        expanded: true,
        width: 'wide',
        class: ['w-full'],
      },
      {
        expanded: true,
        width: 'narrow',
        class: ['w-3/5'],
      },
      {
        expanded: false,
        class: ['w-14.5', 'pt-4xl', 'items-center'],
      },
    ],
    defaultVariants: {
      expanded: true,
      width: 'narrow',
    },
  }),

  reference: cva([
    'hidden',
    'lg:flex',
    'flex-col',
    'lg:rounded-tr-4xl',
    'transition-[width,max-width,padding,opacity]',
    'ease-in-out',
    'duration-300',
    'bg-surface-elevated',
    'overflow-hidden',
  ], {
    variants: {
      open: {
        true: ['w-full', 'max-w-[420px]', 'py-m', 'opacity-100'],
        false: ['w-0', 'max-w-0', 'py-0', 'opacity-0'],
      },
    },
    defaultVariants: {
      open: false,
    },
  }),
}
